// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';

const defaultState = {
  // every 15 seconds
  HEARTBEAT_INTERVAL: 15000,
  loading: false,
  error: null,
  heartbeatScheduler: null,
  unreachableBackendCount: 0,
  MAX_UNREACHABLE_BACKEND_COUNT: 2
};

export default function appReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.heartbeat.ACTION_TYPES.HEARTBEAT_START:
      return { ...state, heartbeatScheduler: action.payload };
    case actions.heartbeat.ACTION_TYPES.HEARTBEAT_STOP:
      return { ...state, heartbeatScheduler: null, error: null };
    case actions.heartbeat.ACTION_TYPES.ERROR:
      return { ...state, error: action.payload, loading: false };
    case actions.heartbeat.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    case actions.heartbeat.ACTION_TYPES.UNREACHABLE_BACKEND:
      return {
        ...state,
        unreachableBackendCount: state.unreachableBackendCount + 1,
        loading: true,
        error: null
      };
    default:
      return state;
  }
}
